import { PersonalSpaceIcon } from './PersonalSpaceIcon'
import { WorkSpaceIcon } from './WorkSpaceIcon'
import { HomeSpaceIcon } from './HomeSpaceIcon'

/**
 * LifeSpaceColorIcon — picks the right life space glyph by id and renders its
 * full-color (`colored`) state. Thin selector over the canonical
 * Personal/Work/Home space icons; used where the life space should read as a
 * colored badge (e.g. the list-mode project switcher). Returns null for unknown
 * life spaces (e.g. "all").
 *
 * @example
 * <LifeSpaceColorIcon lifeSpace="personal" />
 */
export function LifeSpaceColorIcon({ lifeSpace, size = 16 }: { lifeSpace: string; size?: number }) {
  switch (lifeSpace) {
    case 'personal':
      return <PersonalSpaceIcon size={size} colored />
    case 'work':
      return <WorkSpaceIcon size={size} colored />
    case 'home':
      return <HomeSpaceIcon size={size} colored />
    default:
      return null
  }
}
